import { useQueryClient } from 'react-query';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';
import { useCareCreditLocationStatus } from './use-care-credit-location-status';

export type UseCareCreditLocationProviderStatusProps = {
  locationId: string | undefined;
};
export type UseCareCreditLocationProviderOptions = {
  enabled?: boolean;
};
export const useCareCreditLocationProviderStatus = (
  { locationId }: UseCareCreditLocationProviderStatusProps,
  { enabled }: UseCareCreditLocationProviderOptions = {}
) => {
  const queryClient = useQueryClient();

  const { isCareCreditEnabled, isCareCreditLoading } = useCareCreditLocationStatus(locationId);

  const { data, isLoading, ...queryData } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: !!locationId && isCareCreditEnabled && enabled !== false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: () => {
        /**
         * The endpoint doesn't return a 200 "not found" response.
         * It just throws errors. When that happens, the cache doesn't get cleared.
         * So manually clearing it.
         */
        clearCache();
      },
    },
  });

  const clearCache = () => {
    queryClient.setQueryData(queryData.queryKey, undefined);
  };

  const { merchantNumber } = data ?? {};

  const isProviderConnected = !!merchantNumber;

  return {
    ...queryData,
    merchantNumber,
    isProviderConnected,
    isProviderLoading: isCareCreditLoading || isLoading,
  };
};
